<template>
  <div id="app">
  <div style="background:#fff;margin-bottom:28px;" id="navba">
    <div  style="padding-left:0px;">
    <nav  style="padding-left:0px;">
      <div class="navAjs"  >
          <div style="display: flex; align-items: center;">
            <a  href="https://www.lefisc.com.br"> <img src="https://www.lefisc.com.br/monitoramentoncm/img/logo.png" style="width:115px;height:27px;"></a>
            <p @click="pag" style="cursor:pointer;font-size:16px">RECLEF - PIS e COFINS</p>
          </div>     
          <router-link  style="font-weight:600;font-size:13px;"  :to="{ name: 'consulta'}"> Minhas Consultas</router-link>  
      </div>
    </nav>
    </div>
    </div> 
  
    <router-view  />
  </div>
</template>

<script>


export default {
  name: 'App',
  data(){
    return{
      nome:''
    }
  },
  methods:{
    pag(){
      
           this.$router.push({
            name:'principal'
            })
       
    }
  },
  created(){
    
    this.nome  = this.$route.name
    function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

 if(getCookie("hash") == '' || getCookie("hash") == null){
 // window.location="https://www.lefisc.com.br"
 }else{
    this.$store.state.idCliente = getCookie("hash")
    
 }
  },
   watch: {
    $route(rota){    
     this.nome  = rota.name
    }
  }
 
}
</script>

<style>
.navAjs{
  display:flex;height:60px;align-items: center;justify-content: space-between;
  max-width: 1290px; 
  margin:0 auto;
}
#app {
 font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
 text-align: center;
 min-height: 84vh;
color: #212529;
 text-decoration: none !important;
}
.navAjs a{
  text-decoration: none !important;
color:#383838;
  
}
.navAjs p{
  position: relative;
  margin-left:24px;
  display: flex;
  justify-content: space-between;
  color: #383838;
  font-size: 19px !important;
  font-weight: 600 !important;
  margin-top: 17px;
}
.navAjs p::before{
  content: "";
  position: absolute;
  height: 25px;
  width: 1px;
  top:1px;
  left: -14px;
  background: grey;
}
li{
  position: relative;
}
li.active a{
  color: #383838;
}
li.active a::after{
  content: '';
  position: absolute;
  left:-3px;
  top:13px;  
  width: 1px;
  height: 25px;
  background: #000;
  border-left: .7px solid grey;
}
.containerNcm {
  margin: 0 auto;
  max-width: 1200px;
  background: #fff;
  min-height:80vh;
  
}

</style>
